// extracted by mini-css-extract-plugin
export var activeDot = "_49-c";
export var buttonContainer = "_49-9";
export var channelButton = "_49-a";
export var clickable = "_49-d";
export var content = "_49-0";
export var contentFull = "_49-2";
export var contentThird = "_49-1";
export var contentWrapper = "_49-7";
export var description = "_49-5";
export var heightShort = "_49-f";
export var image = "_49-3";
export var imageContainer = "_49-4";
export var selectButton = "_49-e";
export var spinnerContainer = "_49-b";
export var titleContent = "_49-8";
export var titleWrapper = "_49-6";